<script setup lang="ts">
const device = useDevice();
const samples = [
    {
        title: 'نمونه صدای آقا',
        img: '/img/new/smart-ivr/sound-sample-01.webp',
        sound: '/sound/sound-sample-man.mp3',
    },
    {
        title: 'نمونه صدای خانم',
        img: '/img/new/smart-ivr/sound-sample-02.webp',
        sound: '/sound/sound-sample-woman.mp3',
    },
];
</script>

<template>
    <SectionsBase id="sound-samples" class="container">
        <ChipsDivider>نمونه صدا</ChipsDivider>
        <h2>ضبط رایگان پیام خوش‌آمدگویی با صدای گویندگان حرفه‌ای</h2>
        <p class="text-body1-semibold text-gray-400 text-center my-6">اولین تماس، مهم‌ترین تصویر از برند شماست. با خرید مرکز تلفن ابری نواتل، ما متن دلخواه شما را به‌صورت کاملاً رایگان با صدای گویندگان حرفه‌ای (آقا و خانم) ضبط می‌کنیم. نمونه صداها را بشنوید و صدای برندتان را انتخاب کنید.</p>
        <div class="w-full flex-center flex-col lg:flex-row gap-8 lg:gap-20">
            <div
                v-for="sample, index in samples"
                :key="sample.title"
                class="w-full max-w-90 flex flex-col gap-2"
                :data-aos="device.isDesktop.value && (index ? 'fade-right' : 'fade-left')" 
                data-aos-duration="1500"
            >
                <NuxtImg 
                    :src="sample.img"
                    :alt="sample.title"
                    class="w-full"
                />
                <CardsSound :url="sample.sound" />
            </div>
        </div>
    </SectionsBase>
</template>